import {
	queryVehicleDetail,
	getRecommendFinanceProducts,
	getCustomFinanceProducts,
	monthlyPaymentCalculation
} from '@/model'
import { getCurrentCity } from '@/util/location'

// map防止请求覆盖
const customReqMap = new WeakMap()
const paymentReqMap = new WeakMap()

export default {
	namespaced: true,
	state: () => ({
		car: null,
		currentCity: null,
		recommendProduct: null,
		customProducts: [],
		loanDetail: {}
	}),
	getters: {
		commonOpt(state) {
			const { basic, sell_programme } = state.car || {}
			return {
				channel: 'nio_app',
				address_id: (state.currentCity && state.currentCity.code) || '',
				generation_code: (basic && basic.generation) || '',
				total_amount: (sell_programme && sell_programme.sell_price) || 0,
				brand: (basic && basic.brand) || ''
			}
		}
	},
	mutations: {
		setState(state, fields) {
			Object.assign(state, fields)
		}
	},
	actions: {
		// 获取车辆信息
		async fetchCar({ commit }, skuCode) {
			if (!skuCode) throw new Error('缺少车辆编号')
			const { data } = await queryVehicleDetail.get({}, '/' + skuCode)
			if (!data || data.result_code !== 'success' || !data.data || !data.data.basic) {
				throw new Error('car_fetch_failed')
			}
			commit('setState', { car: data.data })
		},
		// 获取当前城市信息
		async fetchCity({ commit }) {
			commit('setState', { currentCity: await getCurrentCity() })
		},
		// 获取推荐金融方案
		async getRecommendProduct({ getters, commit }) {
			const { data } = await getRecommendFinanceProducts.get(getters.commonOpt)
			if (!data || data.result_code !== 'success') {
				throw new Error('finance_recommend_failed')
			}
			commit('setState', { recommendProduct: data.data })
			return data
		},
		// 获取自定义金融方案
		async getCustomProducts({ state, getters, commit }) {
			const request = {}
			customReqMap.set(state, request)
			paymentReqMap.set(state, {})
			commit('setState', { customProducts: [], loanDetail: {} })
			try {
				const { data } = await getCustomFinanceProducts.get(getters.commonOpt)
				if (customReqMap.get(state) !== request) return
				if (!data || data.result_code !== 'success' || !Array.isArray(data.data)) {
					throw new Error('finance_custom_failed')
				}
				commit('setState', { customProducts: data.data })
				return data
			} catch (error) {
				if (customReqMap.get(state) !== request) return
				throw error
			}
		},
		async calculatePayment({ state, getters, commit }, params) {
			const request = {}
			paymentReqMap.set(state, request)
			commit('setState', { loanDetail: {} })
			if (!params.product_code || !params.bank_id || !params.month) return
			try {
				const { data } = await monthlyPaymentCalculation.get({
					address_id: getters.commonOpt.address_id,
					amount: getters.commonOpt.total_amount,
					loanAmount: '',
					...params
				})
				if (paymentReqMap.get(state) !== request) return
				if (!data || data.result_code !== 'success' || !data.data) {
					throw new Error('获取月供计算结果失败')
				}
				commit('setState', { loanDetail: data.data })
				return data.data
			} catch (error) {
				if (paymentReqMap.get(state) !== request) return
				throw error
			}
		},
		// 切换贷款城市
		async changeLoanCity({ state, commit, dispatch }, { city }) {
			if (!city || !city.area_code) return
			const sameCity =
				state.currentCity && String(state.currentCity.code) === String(city.area_code)
			if (sameCity && state.customProducts.length) return
			commit('setState', { currentCity: { code: city.area_code, name: city.name } })
			return dispatch('getCustomProducts')
		},
		// 获取所有数据（车辆、城市、推荐方案、自定义方案）
		async fetchFinanceData({ dispatch }, { skuCode, shouldFetchCity = false }) {
			const requests = [dispatch('fetchCar', skuCode)]
			if (shouldFetchCity) requests.push(dispatch('fetchCity'))
			await Promise.all(requests)
			await Promise.all([dispatch('getRecommendProduct'), dispatch('getCustomProducts')])
		}
	}
}
